import { useMediaQuery } from "@mui/material";
import { useIntersectionObserver } from "@uidotdev/usehooks";
import parse from "html-react-parser";
import { Fragment } from "react";
import Color from "../../../assets/colors";
import { DividerStyled, SectionContainer, TextStyled } from "../styles";
import {
  DescriptionBody,
  DescriptionContainer,
  DescriptionWrapper,
  useStyles,
} from "./styles";

function CompanyDescription(props) {
  const { companyDetail, companySocial, setCurrentTab } = props || {};
  const isDesktop = useMediaQuery("(min-width: 1280px)");
  const isMobile = useMediaQuery("(max-width: 640px)");

  const [ref, entry] = useIntersectionObserver();
  entry?.isIntersecting ? setCurrentTab(2) : null;

  const socialCount = companySocial?.length;

  const classes = useStyles();

  return (
    <SectionContainer
      aria-label="company description section"
      id="CompanyAbout"
      className={classes.scrollBar}
      ref={ref}
    >
      <TextStyled
        variant={"h2"}
        color={"#000"}
        fontSize={"1.25rem"}
        fontWeight={700}
        textTransform={"capitalize"}
        margin={"0 0 1.375rem"}
        aria-label={"company description section title"}
      >
        Our Story
      </TextStyled>
      <DescriptionWrapper $companySocial={socialCount}>
        {companyDetail?.map((desc, index) => {
          return (
            <Fragment key={index}>
              {index === 1 && isMobile ? (
                <DividerStyled sx={{ margin: "0" }} />
              ) : null}
              <DescriptionContainer $companySocial={companySocial.length}>
                <TextStyled
                  color={Color.hiredlyPurple}
                  variant={"h3"}
                  fontSize={"1rem"}
                  fontWeight={700}
                  textTransform={"capitalize"}
                  margin={"0 0 1.5rem"}
                  aria-label={"company description title"}
                >
                  {desc.title}
                </TextStyled>
                <DescriptionBody aria-label="company description body">
                  {parse(desc.body)}
                </DescriptionBody>
              </DescriptionContainer>
            </Fragment>
          );
        })}
      </DescriptionWrapper>
    </SectionContainer>
  );
}

export default CompanyDescription;
